import Alpine from 'alpinejs';
import api, { requireAuth } from './api.js';

function createInkoCreationPrintValidation() {
  return {
    projectId: '',
    loading: true,
    running: false,
    validation: null,

    init() {
      this.projectId = this.$el.dataset.projectId || '';
      if (!requireAuth() || !this.projectId) return;
      this.load();
    },

    async load() {
      this.loading = true;
      try {
        this.validation = await api.getPrintValidation(this.projectId);
      } catch {
        this.validation = null;
      } finally {
        this.loading = false;
      }
    },

    severityClass(severity) {
      if (severity === 'error') return 'inko-severity-error';
      if (severity === 'warning') return 'inko-severity-warning';
      return '';
    },

    async runValidation() {
      this.running = true;
      try {
        this.validation = await api.validatePrint(this.projectId);
        window.toast?.('Validasi selesai.', 'success');
      } catch (e) {
        window.toast?.(e.response?.data?.message || 'Validasi gagal.', 'error');
      } finally {
        this.running = false;
      }
    },
  };
}

Alpine.data('inkoCreationPrintValidation', createInkoCreationPrintValidation);
